import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useMutation } from 'react-query'
import { CrossPostGroup } from 'types'

interface Data {
  cross_post_group: CrossPostGroup
}

const createCrossPostGroup = async (workspaceId: number) => {
  const res = await sendToApi<Data>(`/w/${workspaceId}/cross_post_groups`, {
    method: 'POST',
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error()
  }
  return res.data
}

export const useCreateCrossPostGroup = () => {
  const workspaceId = useCurrentWorkspaceId()

  return useMutation<Data, unknown>('createCrossPostGroup', async () => {
    return createCrossPostGroup(workspaceId)
  })
}
